var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"headline font-weight-bold align-baseline",class:( _obj = { 'px-7 px-lg-0 pt-5 mb-3': !_vm.classes }, _obj[_vm.classes] = _vm.classes, _obj )},[(!_vm.loading)?[_vm._t("default")]:_c('v-skeleton-loader',{attrs:{"type":"heading"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }